
        const styles = new CSSStyleSheet();
        styles.replaceSync(`:root{color-scheme:light dark}body{margin:0;block-size:100vb;display:flex;justify-content:center;align-items:center}.player-box{--inline-size: 980px;inline-size:var(--inline-size);@media screen and (min-width:1400px){--inline-size: 1160px}@media screen and (min-width:2500px){--inline-size: 1920px}>.bilibili-player{block-size:calc(var(--inline-size) / 16 * 9 + 68px)}}
`);
        export default styles;